import template from "./notices-table.html";
import "./notices-table.less";
import moment from "moment";

function controller() {
	const ctrl = this;

	ctrl.getStatusLabel = (notice) => {
		const now = moment();
		const begin = moment(notice.BeginInclusive);
		const end = notice.EndExclusive ? moment(notice.EndExclusive) : null;

		if(end && end.isBefore(now)) {
			return "Expired";
		}
		if(begin.isAfter(now)) {
			return "Scheduled";
		}
		return "Active";
	};

	ctrl.getStatusClass = (notice) => {
		const status = ctrl.getStatusLabel(notice);
		switch(status) {
			case "Active": return "label-success";
			case "Scheduled": return "label-info";
			case "Expired": return "label-default";
			default: return "";
		}
	};

	ctrl.getSeverityIcon = (notice) => {
		if(!notice.Severity) {
			return "";
		}
		switch(notice.Severity.Code) {
			case "INFO": return "zmdi-info";
			case "WARNING": return "zmdi-alert-triangle";
			case "URGENT": return "zmdi-alert-octagon";
			case "CRITICAL": return "zmdi-alert-polygon";
			default: return "";
		}
	};

	ctrl.getSeverityClass = (notice) => {
		if(!notice.Severity) {
			return "";
		}
		switch(notice.Severity.Code) {
			case "INFO": return "severity-info";
			case "WARNING": return "severity-warning";
			case "URGENT": return "severity-urgent";
			case "CRITICAL": return "severity-critical";
			default: return "";
		}
	};

	ctrl.getSeverityLabelClass = (notice) => {
		if(!notice.Severity) {
			return "label-default";
		}
		switch(notice.Severity.Code) {
			case "INFO": return "label-info";
			case "WARNING": return "label-warning";
			case "URGENT": return "label-danger";
			case "CRITICAL": return "label-danger";
			default: return "label-default";
		}
	};

	ctrl.isActive = (notice) => {
		return ctrl.getStatusLabel(notice) === "Active";
	};

	ctrl.handleView = (notice) => {
		if(ctrl.onView) {
			ctrl.onView({ notice });
		}
	};

	ctrl.handleExpire = (notice) => {
		if(ctrl.onExpire) {
			ctrl.onExpire({ notice });
		}
	};
}

export default angular
	.module("vesl.screens.notices.table", [])
	.component("noticesTable", {
		template,
		controller,
		bindings: {
			data: "<",
			paginatorOptions: "<",
			onView: "&",
			onExpire: "&",
			canUpdate: "<"
		}
	}).name;
